import React from 'react';
import HelpPageShell from '../../components/help/HelpPageShell';
import { contractorHelpContent } from '../../content/help/contractorHelpContent';
import { contractorWalkthroughAssets } from '../../content/help/contractorWalkthroughAssets';
import { getHelpDownloadByRole } from '../../content/help/helpDownloads';

interface ContractorHelpPageProps {
  onNavigate: (screen: string) => void;
}

export default function ContractorHelpPage({ onNavigate }: ContractorHelpPageProps) {
  const origin = React.useMemo(() => {
    try { return sessionStorage.getItem('cb.help.origin') || 'contractor-dashboard'; } catch { return 'contractor-dashboard'; }
  }, []);

  const backLabel = origin === 'contractor-dashboard' ? '← Back to Dashboard' : '← Back';

  const handleBack = () => {
    try { sessionStorage.removeItem('cb.help.origin'); } catch {}
    onNavigate(origin);
  };

  return (
    <div>
      <div style={{ background: '#fff', borderBottom: '1px solid #e2e8f0', padding: '10px 24px' }}>
        <button
          onClick={handleBack}
          style={{
            background: 'none',
            border: '1px solid #cbd5e1',
            borderRadius: 8,
            padding: '7px 14px',
            fontSize: 14,
            fontWeight: 600,
            color: '#334155',
            cursor: 'pointer',
          }}
        >
          {backLabel}
        </button>
      </div>
      <HelpPageShell
        role="contractor"
        title="Help Center"
        subtitle="Step-by-step help for finding projects, submitting bids, milestones, updates, and completion."
        sections={contractorHelpContent}
        assets={contractorWalkthroughAssets}
        downloadConfig={getHelpDownloadByRole('contractor')}
        pendingSectionStorageKey="cb.contractor.help.section"
      />
    </div>
  );
}
